<template>
  <div id="Cart">
    <panel
      :Title="$GetIsAnbohSaz() == 'false' ? 'سبد پرداخت' : 'سبد پرداخت قراردادها'"
      :Des="
        $GetIsAnbohSaz() == 'false'
          ? 'اقساط انتخاب‌شده را مدیریت کنید، در صورت نیاز حذف کنید و سپس از طریق درگاه بانکی پرداخت نمایید'
          : 'اقساط انتخاب‌شده را مدیریت کنید و سپس پرداخت را انجام دهید'
      "
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card class="cart-page-card" Classes="bg-dark-Custom">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-shopping-bag ml-2"></i>
          {{ $GetIsAnbohSaz() == "false" ? "لیست اقساط" : "لیست اقساط قرارداد" }}
        </h6>
      </template>
      <template slot="content">
        <div v-if="rows.length === 0" class="cart-empty-state">
          <i class="fas fa-shopping-bag cart-empty-state__icon" aria-hidden="true"></i>
          <p class="cart-empty-state__text">سبد پرداخت شما خالی است</p>
          <button type="button" class="btn btn-outline-success" @click="$router.go(-1)">
            بازگشت
          </button>
        </div>
        <div v-else class="cart-layout">
          <div class="cart-layout__list">
            <div class="cart-cards" dir="rtl">
              <div class="cart-cards__toolbar">
                <input
                  v-model="cardSearch"
                  type="search"
                  class="form-control cart-cards__search"
                  placeholder=" جستجو"
                  aria-label="جستجو در سبد پرداخت"
                />
                <label class="cart-cards__select-all">
                  <input
                    type="checkbox"
                    :checked="allFilteredSelected"
                    :indeterminate.prop="someFilteredSelected && !allFilteredSelected"
                    @change="toggleSelectAll"
                  />
                  <span>انتخاب همه</span>
                </label>
              </div>
              <p
                v-if="filteredCardRows.length === 0"
                class="cart-cards__empty"
              >
                اطلاعاتی یافت نشد
              </p>
              <div v-else class="cart-cards__list">
                <article
                  v-for="(row, index) in filteredCardRows"
                  :key="(row.id || 'cart') + '-' + index"
                  class="cart-card"
                  :class="{ 'is-selected': isSelected(row) }"
                >
                  <label class="cart-card__check">
                    <input
                      type="checkbox"
                      :checked="isSelected(row)"
                      @change="toggleSelect(row)"
                    />
                    <span class="sr-only">انتخاب</span>
                  </label>
                  <div class="cart-card__body">
                    <div class="cart-card__header">
                      <strong class="cart-card__name">{{
                        row.nameFamily != null ? row.nameFamily : "خودم"
                      }}</strong>
                      <span v-if="row.Catrgory" class="cart-card__badge">{{
                        row.Catrgory
                      }}</span>
                    </div>
                    <div class="cart-card__amount">
                      <span dir="ltr">{{
                        $Comma3ragham(row.SumGhabelPar)
                      }}</span>
                      <small>مبلغ قابل پرداخت</small>
                    </div>
                    <div class="cart-card__fields">
                      <div v-if="row.desNoe" class="cart-card__field">
                        <span>نوع</span>
                        <strong>{{ row.desNoe }}</strong>
                      </div>
                      <div v-if="row.vCode" class="cart-card__field">
                        <span>{{
                          $GetIsAnbohSaz() == "false"
                            ? "شماره حساب | تسهیلات"
                            : "شماره قرارداد"
                        }}</span>
                        <strong dir="ltr">{{ row.vCode }}</strong>
                      </div>
                    </div>
                    <div class="cart-card__actions">
                      <button
                        type="button"
                        class="cart-chip cart-chip--remove"
                        @click="deleteOne(row)"
                      >
                        <i class="fas fa-trash" aria-hidden="true"></i>
                        حذف
                      </button>
                    </div>
                  </div>
                </article>
              </div>
              <div class="cart-actions-bar cart-actions-bar--cards">
                <button
                  type="button"
                  class="cart-chip cart-chip--remove Pointer"
                  :disabled="selectedItems.length === 0"
                  @click="DeleteSelected()"
                >
                  <i class="fas fa-trash" aria-hidden="true"></i>
                  حذف موارد انتخاب‌شده
                  <span v-if="selectedItems.length">
                    ({{ selectedItems.length }})
                  </span>
                </button>
              </div>
            </div>

            <div class="cart-table-view">
            <vue-bootstrap4-table
              v-if="$store.state.renderComponent"
              :rows="rows"
              :columns="columns"
              :config="config"
              :classes="classes"
              @on-select-row="onSelectRows"
              @on-unselect-row="onSelectRows"
              @on-all-select-rows="onSelectRows"
              @on-all-unselect-rows="onSelectRows"
            >
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <span class="cart-table__cell">{{ props.row.vbt_id }}</span>
              </template>
              <template slot="SumGhabelPar" slot-scope="props">
                <span class="cart-table__cell cart-table__amount">
                  {{ $Comma3ragham(props.row.SumGhabelPar) }}
                </span>
              </template>
              <template slot="nameFamily" slot-scope="props">
                <span class="cart-table__cell">
                  {{ props.row.nameFamily != null ? props.row.nameFamily : "خودم" }}
                </span>
              </template>
            </vue-bootstrap4-table>
            <div class="cart-actions-bar">
              <button
                type="button"
                class="cart-chip cart-chip--remove Pointer"
                :disabled="selectedItems.length === 0"
                @click="DeleteSelected()"
              >
                <i class="fas fa-trash" aria-hidden="true"></i>
                حذف موارد انتخاب‌شده
              </button>
            </div>
            </div>
          </div>

          <aside class="cart-layout__checkout">
            <div class="cart-summary-panel">
              <div class="cart-summary-panel__label">جمع مبالغ قابل پرداخت</div>
              <div class="cart-summary-panel__amount">
                {{ $Comma3ragham(GetSumCart()) }}
                <span class="cart-summary-panel__unit">{{ $GetVahedPool() }}</span>
              </div>
              <div class="cart-summary-panel__persian">{{ Mab2persian }}</div>
            </div>
            <payment @GatewayCode="Get_GatewayCode" @FixVarizGhest="FixVarizGhest">
              <template v-slot:ContentButtonPayment>
                <button
                  type="button"
                  :disabled="GetSumCart() < 10000"
                  class="btn btn-success cart-pay-btn"
                  @click="Payment"
                >
                  پرداخت {{ $Comma3ragham(GetSumCart()) }}
                </button>
              </template>
            </payment>
          </aside>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import Num2persian from "num2persian";
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Payment from "./Payment.vue";

export default {
  components: { Panel, NetPaCard, Payment },
  data() {
    return {
      rows: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
          slot_name: "row",
        },
        {
          label: "دسته بندی",
          name: "Catrgory",
        },
        {
          label: "نوع ",
          name: "desNoe",
        },
        {
          label: "مشخصات",
          name: "nameFamily",
          slot_name: "nameFamily",
        },
        {
          label:
            this.$GetIsAnbohSaz() == "false"
              ? "شماره حساب | تسهیلات"
              : "شماره قرارداد",
          name: "vCode",
        },
        {
          label: "مبلغ قابل پرداخت",
          name: "SumGhabelPar",
          slot_name: "SumGhabelPar",
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: true,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table table-hover cart-table",
      },
      selectedItems: [],
      cardSearch: "",
      GatewayCode: null,
      FixVariz: null,
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: "Post",
        Action: "VarizGorohi/SetVarizGorohi",
        Token: this.$session.get("TokenNetPa"),
      },
    };
  },
  methods: {
    GetList() {
      let list = this.$store.state.Netpa_Cart;
      this.selectedItems = [];

      if (list.length == 0) {
        this.rows = [];
      } else {
        this.rows = [];
        for (let index = 0; index < list.length; index++) {
          for (let jndex = 0; jndex < list[index].item.length; jndex++) {
            list[index].item[jndex].Catrgory = list[index].lbl;
            this.rows.push(list[index].item[jndex]);
          }
        }
        this.GetSumCart();
      }
    },
    onSelectRows(payload) {
      this.selectedItems = (payload && payload.selected_items) || [];
    },
    isSelected(row) {
      return this.selectedItems.some((item) => item.id === row.id);
    },
    toggleSelect(row) {
      if (this.isSelected(row)) {
        this.selectedItems = this.selectedItems.filter(
          (item) => item.id !== row.id,
        );
      } else {
        this.selectedItems = this.selectedItems.concat([row]);
      }
    },
    toggleSelectAll() {
      if (this.allFilteredSelected) {
        const ids = this.filteredCardRows.map((row) => row.id);
        this.selectedItems = this.selectedItems.filter(
          (item) => ids.indexOf(item.id) === -1,
        );
      } else {
        const current = this.selectedItems.slice();
        this.filteredCardRows.forEach((row) => {
          if (!current.some((item) => item.id === row.id)) {
            current.push(row);
          }
        });
        this.selectedItems = current;
      }
    },
    deleteOne(row) {
      this.deleteByIds([row.id]);
    },
    DeleteSelected() {
      const ids = this.selectedItems.map((item) => item.id);
      if (!ids.length) {
        this.$mySweetDefaultTost(
          " ",
          "موردی برای حذف انتخاب نشده است",
          "warning",
          2000,
        );
        return;
      }
      this.deleteByIds(ids);
    },
    deleteByIds(ids) {
      if (!ids.length) return;

      let list = this.$store.state.Netpa_Cart;
      for (let index = list.length - 1; index >= 0; index--) {
        if (list[index].item && list[index].item.length > 0) {
          list[index].item = list[index].item.filter(
            (item) => ids.indexOf(item.id) === -1,
          );
          if (list[index].item.length === 0) {
            list.splice(index, 1);
          }
        }
      }

      if (list.length < 1) {
        this.$store.state.Netpa_Cart = [];
        this.$router.go(-1);
        return;
      }
      this.GetList();
    },
    GetSumCart() {
      var Sum = 0;
      for (let index = 0; index < this.rows.length; index++) {
        Sum += Number((this.rows[index].SumGhabelPar + "").replace(/,/g, ""));
      }
      return Sum;
    },
    Get_GatewayCode(val) {
      this.GatewayCode = val;
    },
    FixVarizGhest(val) {
      this.FixVariz = val;
    },
    Payment() {
      if (this.GatewayCode == 0) {
        if (this.$session.get("CustCode") == 801) {
          this.$swal(
            "اختلال در پرداخت با درگاه",
            "مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)",
            "warning",
          );
        } else {
          this.$mySweetDefaultTost(
            "عدم انتخاب درگاه",
            "درگاهی برای سامانه تنظیم نشده است",
            "warning",
            3000,
          );
        }
      } else {
        const WwwtblVarizGorohiRiz = [];
        for (let index = 0; index < this.rows.length; index++) {
          if (
            this.rows[index].ListTaahodatRiz &&
            this.rows[index].ListTaahodatRiz.length > 0
          ) {
            for (
              let Jndex = 0;
              Jndex < this.rows[index].ListTaahodatRiz.length;
              Jndex++
            ) {
              WwwtblVarizGorohiRiz.push({
                WwwtblTaahodatId: this.rows[index].id,
                Mablagh:
                  this.rows[index].ListTaahodatRiz[Jndex].mablaghGhest +
                  (this.rows[index].ListTaahodatRiz[Jndex].mabJarime -
                    this.rows[index].ListTaahodatRiz[Jndex].mabBakhshesh),
                SharhRiz:
                  " پرداخت گروهی (قسط شماره " +
                  this.rows[index].ListTaahodatRiz[Jndex].shomareGhest +
                  ") _ " +
                  this.rows[index].vCode +
                  " ___ " +
                  "مبلغ بخشش: " +
                  this.rows[index].ListTaahodatRiz[Jndex].mabBakhshesh +
                  " ___ " +
                  "مبلغ جریمه :" +
                  this.rows[index].ListTaahodatRiz[Jndex].mabJarime,
                WwwtblAzaId: this.rows[index].wwwtblAzaId,
                BnpCashDBtblTaahodatId: this.rows[index].bnpCashDBtblTaahodatId,
                BnpCashDBtblAzaId: this.rows[index].bnpCashDBtblAzaId,
                MablaghJarime:
                  this.rows[index].ListTaahodatRiz[Jndex].mabJarime -
                  this.rows[index].ListTaahodatRiz[Jndex].mabBakhshesh,
                TarixGhest: this.rows[index].ListTaahodatRiz[Jndex].tarixGhest,
                IsTaahodatRiz: true,
              });
            }
          } else {
            WwwtblVarizGorohiRiz.push({
              WwwtblTaahodatId: this.rows[index].id,
              Mablagh: this.rows[index].SumGhabelPar,
              SharhRiz: " پرداخت گروهی  " + this.rows[index].vCode,
              WwwtblAzaId: this.rows[index].wwwtblAzaId,
              BnpCashDBtblTaahodatId: this.rows[index].bnpCashDBtblTaahodatId,
              BnpCashDBtblAzaId: this.rows[index].bnpCashDBtblAzaId,
              MablaghJarime: this.rows[index].wwwJarime,
              TarixGhest: this.rows[index].minTarGhestBedehkar,
              IsTaahodatRiz: false,
            });
          }
        }

        this.DataAxios_Variz.ArryfildValue.Mablagh = this.GetSumCart();
        this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0;
        this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate;
        this.DataAxios_Variz.ArryfildValue.Sharh = "پرداخت گروهی";
        this.DataAxios_Variz.ArryfildValue.ZamanInsert =
          this.$store.state.JalaliDate;
        this.DataAxios_Variz.ArryfildValue.CustCode = Number(
          this.$session.get("UserInfoNetPa").custCode,
        );
        this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538;
        this.DataAxios_Variz.ArryfildValue.wwwtblAzaId =
          this.$session.get("UserInfoNetPa").wwwtblAzaId;
        this.DataAxios_Variz.ArryfildValue.StatusVariz = 2;
        this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz =
          WwwtblVarizGorohiRiz;
        this.$PostData(this.DataAxios_Variz).then((result) => {
          if (result.status === "Success") {
            if (this.GatewayCode == 0) {
              if (this.$session.get("CustCode") == 801) {
                this.$swal(
                  "اختلال در پرداخت با درگاه",
                  "مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)",
                  "warning",
                );
              } else {
                this.$mySweetDefaultTost(
                  "عدم انتخاب درگاه",
                  "درگاهی برای سامانه تنظیم نشده است",
                  "warning",
                  3000,
                );
              }
            } else {
              this.$Payment(
                this.GatewayCode + "",
                JSON.stringify(this.GetSumCart()),
                this.$session.get("UserInfoNetPa").ozvName +
                  " " +
                  this.$session.get("UserInfoNetPa").ozvFamily,
                this.$session.get("UserInfoNetPa").email,
                this.$session.get("UserInfoNetPa").mobile,
                WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
                "",
                this.rows[0].vCode,
                "سبد اقساط",
                JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblAzaId),
                this.$session.get("UserInfoNetPa").custCode,
                JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblShobeId),
                result.idRepoMaster,
                this.$session.get("UserInfoNetPa").codeMeli,
                this.$session.get("UserInfoNetPa").ozvName +
                  " " +
                  this.$session.get("UserInfoNetPa").ozvFamily,
                this.$session.get("UserInfoNetPa").mobile,
                this.$session.get("UserInfoNetPa").codeMeli,
              );
            }
          } else {
            this.$mySweetDefaultTost(
              " ",
              " در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید",
              "warning",
              4000,
            );
            this.DeleteAllItemsCart();
          }
        });
      }
    },
    DeleteAllItemsCart() {
      this.$store.state.Netpa_Cart = [];
      this.GetList();
      this.$router.go(-1);
    },
  },
  mounted() {
    this.GetList();
  },
  computed: {
    Mab2persian() {
      var Mab = this.GetSumCart();
      return Num2persian(Mab) + " ریال ";
    },
    filteredCardRows() {
      const q = (this.cardSearch || "").trim().toLowerCase();
      if (!q) return this.rows;
      return this.rows.filter((row) => {
        const hay = [
          row.Catrgory,
          row.desNoe,
          row.nameFamily != null ? row.nameFamily : "خودم",
          row.vCode,
          row.SumGhabelPar,
        ]
          .filter((v) => v != null && v !== "")
          .join(" ")
          .toLowerCase();
        return hay.includes(q);
      });
    },
    allFilteredSelected() {
      return (
        this.filteredCardRows.length > 0 &&
        this.filteredCardRows.every((row) => this.isSelected(row))
      );
    },
    someFilteredSelected() {
      return this.filteredCardRows.some((row) => this.isSelected(row));
    },
  },
};
</script>
<style scoped>
.cart-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1.5rem 1rem;
  text-align: center;
}

.cart-empty-state__icon {
  font-size: 2.5rem;
  color: #c5cdd8;
}

.cart-empty-state__text {
  margin: 0;
  font-size: 15px !important;
  color: #6c757d;
}

.cart-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

.cart-layout__list,
.cart-layout__checkout {
  min-width: 0;
}

.cart-actions-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}

.cart-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 32px;
  margin: 0;
  padding: 0.25rem 0.7rem;
  color: #b44f46;
  border: 1px solid #f0d4d1;
  border-radius: 10px;
  background: #fcefed;
  box-shadow: 0 1px 2px rgba(41, 52, 95, 0.05);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition:
    color 0.15s ease,
    border-color 0.15s ease,
    background-color 0.15s ease;
}

.cart-chip i {
  flex-shrink: 0;
  font-size: 11px;
}

.cart-chip:not(:disabled):hover,
.cart-chip:not(:disabled):focus {
  color: #9a3d36;
  border-color: #e3b4af;
  background: #f8e3e0;
  outline: none;
}

.cart-chip:focus-visible {
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.cart-chip:disabled {
  color: #8a96a3;
  border-color: #e8eef2;
  background: #f4f6f8;
  cursor: not-allowed;
  box-shadow: none;
}

.cart-layout__checkout {
  padding: 12px;
  border: 1px solid #e8eef2;
  border-radius: 14px;
  background: #f8fafc;
}

.cart-summary-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 12px;
  padding-bottom: 12px;
  text-align: center;
  border-bottom: 1px solid #e8eef2;
}

.cart-summary-panel__label {
  margin: 0;
  color: #29345f;
  font-size: 13px !important;
  font-weight: 700;
}

.cart-summary-panel__amount {
  color: #29345f;
  font-size: 22px !important;
  font-weight: 800;
  line-height: 1.3;
}

.cart-summary-panel__unit {
  margin-right: 0.25rem;
  color: #6c757d;
  font-size: 13px !important;
  font-weight: 600;
}

.cart-summary-panel__persian {
  margin: 0;
  color: #6c757d;
  font-size: 12px !important;
  line-height: 1.6;
}

.cart-pay-btn {
  width: 100%;
  min-height: 42px;
  border-radius: 12px;
  font-weight: 700;
}

@media (min-width: 992px) {
  .cart-layout {
    grid-template-columns: minmax(0, 1fr) 280px;
  }
}

.cart-cards {
  display: none;
}

.cart-cards__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin: 0 0 0.85rem;
}

.cart-cards__search {
  flex: 1 1 12rem;
  min-width: 0;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dce1e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(42, 63, 84, 0.06);
}

.cart-cards__search:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.cart-cards__select-all {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 40px;
  color: #29345f;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.cart-cards__select-all input,
.cart-card__check input {
  width: 18px;
  height: 18px;
  margin: 0;
  accent-color: #287db4;
  cursor: pointer;
}

.cart-cards__empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

.cart-cards__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.cart-card {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.95rem 1rem 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

.cart-card.is-selected {
  border-color: #cfe4f2;
  background: #f7fbfe;
}

.cart-card__check {
  flex: 0 0 auto;
  margin-top: 0.2rem;
}

.cart-card__body {
  flex: 1 1 auto;
  min-width: 0;
}

.cart-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.55rem;
}

.cart-card__name {
  min-width: 0;
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

.cart-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0.15rem 0.65rem;
  border-radius: 999px;
  color: #287db4;
  background: #edf5fb;
  font-size: 12px;
  font-weight: 800;
}

.cart-card__amount {
  margin: 0 0 0.75rem;
  color: #166c3b;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.3;
}

.cart-card__amount small {
  margin-right: 0.3rem;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.cart-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.cart-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.cart-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.cart-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.cart-card__actions {
  margin-top: 0.75rem;
}

.cart-actions-bar--cards {
  justify-content: stretch;
}

@media (max-width: 767px) {
  .cart-cards {
    display: block;
  }

  .cart-table-view {
    display: none;
  }

  .cart-chip,
  .cart-pay-btn,
  .cart-actions-bar--cards .cart-chip {
    width: 100%;
  }

  .cart-layout {
    padding-bottom: 0.25rem;
  }

  .cart-layout__checkout {
    position: sticky;
    bottom: 0;
    z-index: 8;
    margin: 0 -0.15rem;
    padding: 0.75rem 0.85rem 0.85rem;
    border-radius: 16px 16px 0 0;
    background: #fff;
    box-shadow: 0 -8px 24px rgba(41, 52, 95, 0.1);
  }

  .cart-summary-panel {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 0.65rem;
    padding-bottom: 0.65rem;
    text-align: right;
  }

  .cart-summary-panel__amount {
    font-size: 18px !important;
  }

  .cart-summary-panel__persian {
    flex: 1 1 100%;
  }
}
</style>
<style>
#Cart .cart-page-card.netpa-card,
#Cart .cart-page-card {
  height: auto !important;
}

#Cart .netpa-card__title h6 > i.fas {
  color: #068997 !important;
  background: #e9f9fb !important;
  box-shadow: inset 0 0 0 1px rgba(5, 184, 200, 0.16);
}

#Cart .cart-table {
  margin-bottom: 0;
  font-size: 13px !important;
}

#Cart .cart-table thead th {
  background: #f0f2f5;
  color: #2a3f54;
  font-weight: 700;
  border-color: #e8ecf1;
  white-space: nowrap;
}

#Cart .cart-table tbody td {
  vertical-align: middle;
  color: #2a3f54;
}

#Cart .cart-table__amount {
  font-weight: 700;
  color: #28a745;
}

#Cart .cart-table__cell {
  display: inline-block;
  margin: 0;
}

#Cart .vbt-search-wrapper {
  padding: 0.75rem;
  background: #f8f9fb;
  border-bottom: 1px solid #e8ecf1;
}

#Cart .cart-table input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  accent-color: #287db4;
}

@media (max-width: 767px) {
  body.has-mobile-bottom-nav #Cart .cart-layout__checkout {
    bottom: calc(
      var(--mobile-bottom-nav-height, 68px) + env(safe-area-inset-bottom, 0px)
    );
  }
}
</style>
